import React, { useState } from 'react';
import './UserProfile.css';

function UserProfile() {
  // Por ahora simulamos un usuario. En el paso 2, esto vendrá de la DB.
  const [user] = useState({
    nombre: "Benjamín",
    apellido: "JQ",
    email: "benjamin@ejemplo.com",
    telefono: "906131514",
    fechaRegistro: "06/04/2026",
    avatar: "BJ"
  });

  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar-large">{user.avatar}</div>
          <h2>{user.nombre} {user.apellido}</h2>
          <span className="user-badge">Cliente Premium</span>
        </div>

        <div className="profile-details">
          <div className="detail-group">
            <label>Correo Electrónico</label>
            <p>{user.email}</p>
          </div>
          <div className="detail-group">
            <label>Teléfono</label>
            <p>{user.telefono}</p>
          </div>
          <div className="detail-group">
            <label>Miembro desde</label>
            <p>{user.fechaRegistro}</p>
          </div>
        </div>

        <div className="profile-actions">
          <button className="btn-edit">Editar Perfil</button>
          <button className="btn-history">Mis Reservas</button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;